import { Flexbox, Form } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'

function ClassificationFields({
  errors,
  fetchingPriorities,
  priorities,
  touched,
}) {
  return (
    <>
      <Flexbox.Column className="col-12">
        <Form.Group
          className={`${
            touched?.description && errors?.description ? 'has-error' : ''
          }`}
        >
          <Form.Label htmlFor="description">
            Descrição <span className="text-error">*</span>
          </Form.Label>
          <Form.ValidationField
            name="description"
            id="description"
            placeholder="Ex: Atropelamento com fraturas expostas"
          />
          {touched?.description && errors?.description ? (
            <Form.Hint className="text-error">{errors.description}</Form.Hint>
          ) : null}
        </Form.Group>
      </Flexbox.Column>
      <Flexbox.Column className="col-12">
        {fetchingPriorities ? (
          <div className="columns mx-1 mb-2">
            <div className="column col-auto loading" />
            <div className="column">
              <cite>Buscando prioridades</cite>
            </div>
          </div>
        ) : (
          <Form.Group
            className={`${
              touched?.priorityId && errors?.priorityId ? 'has-error' : ''
            }`}
          >
            <Form.Label htmlFor="priorityId">
              Prioridade <span className="text-error">*</span>
            </Form.Label>
            <Form.ValidationField name="priorityId">
              {({ field }) => (
                <Form.Select
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...field}
                  id="priorityId"
                  className="select-sm"
                >
                  <option value="">Selecione uma prioridade</option>
                  {priorities.map((priority) => (
                    <option key={priority?.id} value={priority?.id}>
                      {priority?.title} - {priority?.description}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Form.ValidationField>
            {touched?.priorityId && errors?.priorityId ? (
              <Form.Hint className="text-error">{errors.priorityId}</Form.Hint>
            ) : null}
          </Form.Group>
        )}
      </Flexbox.Column>
    </>
  )
}

ClassificationFields.propTypes = {
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  fetchingPriorities: PropTypes.bool.isRequired,
  priorities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  ).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default ClassificationFields
